module.exports = __webpack_public_path__ + "img/dreidel.f9ede877.svg";